<template>
  <div class="header-style-4 mx-0 px-0">
    <div class="row px-4 mx-0 pt-xl-4 pt-md-4">
      <div
        class="iq-top-navbar fixed-menu col-xl-12 col-md-12 col-sm-6 offset-xl-0 text-center responsive-xl-md rounded p-2 bg-dark"
        data-aos="fade-down"
      >
        <div class="container-fluid p-0">
          <div
            class="iq-navbar-custom d-flex align-items-center justify-content-between"
          >
            <div
              class="iq-navbar-logo d-flex align-items-center justify-content-between"
            >
              <router-link to="/dashboard" class="header-logo">
                <img
                  src="/img/HXLogoWhite.png"
                  class="img-fluid rounded-normal"
                  alt="logo"
                  style="width: 90%"
                />
              </router-link>
            </div>
            <div class="" v-if="visibleItems">
              <div class="row py-2 mx-0 px-0">
                <template v-for="dataItem of dataGroupFiltered?.items">
                  <div
                    v-if="dataItem.nivel.includes(usuario.rol.nivel)"
                    class="text-center"
                    :key="dataItem.id"
                    style="width: 90px"
                  >
                    <div
                      @click="$router.push(dataItem.path)"
                      class="mb-1 text-center"
                    >
                      <img
                        class="img-fluid text-center p-0 m-0 zoom filter"
                        :src="dataItem.icon"
                        alt=""
                        style="width: 6.5vh"
                      />
                      <br />
                    </div>
                    <span
                      @click="$router.push(dataItem.path)"
                      class="text-center"
                      style="font-size: 0.8rem"
                      ><b>{{ dataItem.title }}</b></span
                    >
                  </div>
                </template>
              </div>
            </div>
            <nav class="navbar navbar-expand-lg navbar-light px-0 mx-0">
              <div class="row">
                <div class="col-xl-12 col-md-12">
                  <ul class="navbar-nav ml-auto navbar-list align-items-center">
                    <li class="nav-item nav-icon search-content" v-nav-toggle>
                      <a
                        href="#"
                        class="search-toggle rounded dropdown-toggle"
                        id="dropdownSearch"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="ri-search-line"></i>
                      </a>
                      <div
                        class="iq-search-bar iq-sub-dropdown dropdown-menu"
                        aria-labelledby="dropdownSearch"
                      >
                        <form action="#" class="searchbox p-2">
                          <div class="form-group mb-0 position-relative">
                            <input
                              type="text"
                              class="text search-input"
                              placeholder="type here to search..."
                            />
                            <a href="#" class="search-link"
                              ><i class="ri-search-line"></i
                            ></a>
                          </div>
                        </form>
                      </div>
                    </li>
                    <!-- canjes and market -->
                    <li
                      v-if="
                        usuario.id === '6dcf077b-ed9c-43c0-9a26-cd36309c66e6' ||
                        usuario.id === 'e912f5f1-201a-4e5b-7183-08dafa2d6839'
                      "
                      class="caption-content mr-3"
                      v-sidebar-toggle
                      @click="$router.push('/helex/canjes')"
                    >
                      <i
                        class="fas fa-regular fa-store zoom"
                        style="font-size: 2.5rem"
                      ></i>
                      <vs-button
                        size="small"
                        dark
                        class="position-absolute px-1"
                        style="right: 25px !important; top: -20px"
                      >
                        <b>{{ totalCoins }}</b>
                        <img
                          style="width: 20px"
                          loading="lazy"
                          src="/img/coins.png"
                          alt="coins"
                      /></vs-button>
                    </li>

                    <!-- notificaciones -->
                    <li
                      class="caption-content mr-1"
                      v-sidebar-toggle
                      @click="$router.push('/helex/Tickets')"
                    >
                      <i
                        class="fas fa-regular fa-headset zoom"
                        style="font-size: 2.5rem"
                      ></i>
                      <vs-button
                        circle
                        relief
                        danger
                        v-if="listaTickets.length > 0"
                        class="position-absolute"
                        style="left: 15px !important; top: -20px"
                        >{{ listaTickets.length }}</vs-button
                      >

                      <!-- <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret id="dropdown-aria " dropleft>
                        <template #button-content>
                          <i class="fas fa-bell zoom text-white" style="font-size: 2rem"></i>
                          <b-badge class="position-absolute" style="right: 2px" variant="danger">2</b-badge>
                        </template>
                        <b-dropdown-header id="dropdown-header-1">Notificaciones</b-dropdown-header>
                        <b-dropdown-item-button aria-describedby="dropdown-header-1">
                          <div class="text-wrap py-2" style="width: 300px">
                            <b-badge variant="success">Nueva</b-badge>
                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Culpa, impedit. Culpa cum sed libero voluptatum! Aspernatur libero mollitia modi! Rerum
                            doloribus repellendus quod, itaque deleniti praesentium veniam nihil dignissimos nostrum!
                          </div>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button aria-describedby="dropdown-header-1">
                          <div class="text-wrap py-2" style="width: 300px">
                            <b-badge variant="success">Nueva</b-badge>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui consequatur asperiores
                          </div>
                        </b-dropdown-item-button>
                      </b-dropdown> -->
                    </li>

                    <!-- <Fullscreen /> -->
                    <li class="icon-item">
                      <IconChatIA 
                      @click="$store.commit('showChatIA', true)"
                      style="height: 45px; width: 45px; fill: white; "/>
                    </li>

                    <li class="caption-content" v-sidebar-toggle>
                      <span @click="showModal()">
                        <!-- <a href="#openModal"> -->
                        <img
                          src="../../../../assets/images/Menu-hamburguesa.png"
                          class="img-fluid zoom"
                          style="max-width: 70%"
                          alt=""
                        />
                        <!-- </a> -->
                      </span>
                    </li>
                    <li
                      class="caption-content"
                      v-sidebar-toggle
                      @click="$router.push('/')"
                    >
                      <span>
                        <img
                          src="../../../../assets/images/boton-on-off.png"
                          class="img-fluid zoom"
                          style="max-width: 70%"
                          alt=""
                        />
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="responsive-sm">
      <div class="pt-4" style="background-color: #102444">
        <div class="row">
          <div class="col-2"></div>
          <div class="col-8 text-center">
            <router-link to="/dashboard" class="text-center mt-0 pt-0">
              <img
                src="/img/HXLogoWhite.png"
                class="rounded-normal mt-0 pt-0"
                alt="logo"
                style="max-width: 200px !important"
              />
            </router-link>
          </div>
          <div class="col-1 text-center mx-0 px-0">
            <span @click="showModal()">
              <img
                src="../../../../assets/images/Menu-hamburguesa.png"
                class="zoom pl-0"
                style="max-width: 40px !important"
                alt=""
              />
            </span>
          </div>
        </div>
        <div id="app" v-if="visibleItems">
          <div class="px-3 pb-3 pt-3">
            <horizontal-scroll class="pb-2" style="white-space: nowrap">
              <template v-for="dataItem of dataGroupFiltered?.items">
                <span
                  v-if="dataItem.nivel.includes(usuario.rol.nivel)"
                  class="text-center btn btn-dark mx-1 px-2 py-1"
                  :key="dataItem.id"
                >
                  <b
                    @click="$router.push(dataItem.path)"
                    style="font-size: 0.9rem"
                    >{{ dataItem.title }}</b
                  >
                </span>
              </template>
            </horizontal-scroll>
          </div>
        </div>
      </div>
      <div class=""></div>
    </div>
    <modal />
    <!-- <div class="bg-pay-horizontal">
         <div class="container">           
            <div class="white-bg-menu fixed">
               <div class="iq-menu-horizontal">
                  <nav class="iq-sidebar-menu" id="5">
                    
                     <div class="iq-sidebar-logo d-flex align-items-center justify-content-between">
                           <router-link to="/" class="header-logo">
                              <img :src="sidelogo" class="img-fluid rounded-normal" alt="logo">
                           </router-link> 
                           <div class="iq-menu-bt-sidebar">
                              <i class="las la-bars wrapper-menu"></i>
                           </div>
                     </div>
                     <HoverMenu :items="sidebarItems" :sidebarGroupTitle="sidebarGroupTitle" className="iq-menu d-flex mn-center" :enableCustomIcon="true" />
                  </nav>
               </div>
            </div>
         </div>
      </div> -->
  </div>
</template>
<script>
// import Fullscreen from "../../../fullscreen/Fullscreen";
import sideBarItem from "@/JsonData/header.json";
import { core } from "../../../../config/pluginInit";
import { mapGetters, mapMutations } from "vuex";
import modal from "../../../helexium/modalHome.vue";
import dataGroup from "./groups.json";
import IconChatIA from '@/components/assistant/IconChatIA.vue';

// import ModeSwitch from    "../../../../components/mode/ModeSwitch.vue";

import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";
//../../../components/helexium/modalHome.vue"

export default {
  props: ["visibleItems"],
  sockets: {
    connect: function () {
      console.log(
        "conectado a cockets. en app.vue***************************************************************"
      );
    },
    nuevo_mensaje: async function (data) {
      let usuario = JSON.parse(localStorage.getItem("setPersonaAct")) || null;

      console.log(data);
      if (usuario != null) {
        //if (data.ParaId == usuario.id || (data.ParaId == null && usuario.rol.nivel == 4)) {
        this.getData();
        //}
      }
    },
  },
  name: "HeaderStyle10",
  components: { modal, HorizontalScroll, IconChatIA },
  // components: { Fullscreen, modal, HorizontalScroll },
  data() {
    return {
      sidebarItems: sideBarItem,
      sidebarGroupTitle: true,
      dataGroup: dataGroup,
      group: 0,
      dataGroupFiltered: {},
      usuario: {},
      listaTickets: [],
      dark: null,
      listRangosEvaluaciones: {
        empresaId: null,
        nombre_empresa: null,
        evaluadoId: null,
        nombreEvaluado: null,
        r_50_59: 0,
        r_60_74: 0,
        r_75_84: 0,
        r_85_94: 0,
        r_95_100: 0,
      },
      listCanjes: [
        {
          id: null,
          beneficioId: null,
          beneficio: null,
          personaId: null,
          areaId: null,
          categoria: null,
          coins: null,
          fecha: null,
        },
      ],
    };
  },
  beforeUpdate() {
    this.changeMode();
  },
  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    console.log(this.usuario);

    this.listCanjes = [];
    await this.getCanjesLog();
    await this.getListRangosEvaluacionesPersona();
    this.handleCoins();

    console.log(this.totalCoins);
    await this.getData();
    this.$store.watch(
      (state) => [state.group, state.newChat].join(),
      () => {
        //console('***************************',this.$store.state.group)
        this.dataGroupFiltered =
          this.dataGroup.data[this.$store.state.group - 1]; // this.dataGroup.data[this.group];
        // this.modalShowLocal = this.$store.state.modalShow;
        //console("actualizando modalshowlocal en modalhome", this.dataGroup);
        // console(
        //   "actualizando modalshowlocal en modalhome",
        //   this.dataGroupFiltered
        // );
        this.getData();
      }
    );

    this.dataGroupFiltered =
      this.dataGroup.data[this.$store.state.group - 1] ||
      this.dataGroup.data[localStorage.getItem("group") - 1]; // this.dataGroup.data[this.group];
    // console("datagroup ", this.dataGroupFiltered);
    // alert(this.dark)

    core.changesidebar();
  },
  computed: {
    ...mapGetters({
      appName: "appName",
      logo: "~/img/HXWhite.png",
      sidelogo: "logo",
      name: "name",
      image1: "image1",
      getTotalCanjes: "getTotalCanjes",
      getTotalCoins: "getTotalCoins",
      getIsAvatar: "getIsAvatar",
      getGananciasCoinsTasks: "getGananciasCoinsTasks",
      getGananciasCoinsRangoEvaluaciones: "getGananciasCoinsRangoEvaluaciones",
    }),
    totalCoins() {
      return this.getTotalCoins;
    },
    totalCanjes() {
      return this.getTotalCanjes;
    },
    isAvatar() {
      return this.getIsAvatar;
    },
    tasksCoins() {
      return this.getGananciasCoinsTasks;
    },
    rangoEvaluacionesCoins() {
      return this.getGananciasCoinsRangoEvaluaciones;
    },
  },
  methods: {
    ...mapMutations({
      setTotalCoins: "setTotalCoins",
      setTotalCanjes: "setTotalCanjes",
      setIsAvatar: "setIsAvatar",
      setGananciasCoinsTasks: "setGananciasCoinsTasks",
      setGananciasCoinsRangoEvaluaciones: "setGananciasCoinsRangoEvaluaciones",
    }),
    updateTotalCoins(newValue) {
      this.setTotalCoins(newValue);
    },
    updateTotalCanjes(newValue) {
      this.setTotalCanjes(newValue);
    },
    updateIsAvatar(newValue) {
      this.setIsAvatar(newValue);
    },
    updateTasksCoins(newValue) {
      this.setGananciasCoinsTasks(newValue);
    },
    updateRangoEvaluacionesCoins(newValue) {
      this.setGananciasCoinsRangoEvaluaciones(newValue);
    },
    handleCoins() {
      let canjes = this.listCanjes.reduce(
        (TotalCanje, canje) => TotalCanje + parseInt(canje.coins),
        0
      );
      this.updateTotalCanjes(canjes);
      this.updateTotalCoins(this.handleGanancias() - canjes);
    },
    handleGanancias() {
      let total = 0;

      // shared coins
      console.log(this.usuario.sharedCoins);

      if (this.usuario.sharedCoins !== null) {
        total += this.usuario.sharedCoins;
      }

      // avatar
      if (this.usuario.avatar !== null && this.usuario.stringAvatar !== null) {
        total += 5;
        this.updateIsAvatar(true);
      }
      // tareas

      // evaluaciones

      if (this.listRangosEvaluaciones.empresaId !== null) {
        const { r_50_59, r_60_74, r_75_84, r_85_94, r_95_100 } =
          this.listRangosEvaluaciones;

        let newDataRanges = {
          ...this.getGananciasCoinsRangoEvaluaciones,
          r_50_59: { cant: r_50_59, ganTotal: 1 * r_50_59 },
          r_60_74: { cant: r_60_74, ganTotal: 5 * r_60_74 },
          r_75_84: { cant: r_75_84, ganTotal: 7 * r_75_84 },
          r_85_94: { cant: r_85_94, ganTotal: 8 * r_85_94 },
          r_95_100: { cant: r_95_100, ganTotal: 10 * r_95_100 },
        };

        console.log(newDataRanges);
        this.updateRangoEvaluacionesCoins(newDataRanges);

        if (r_50_59 !== 0) {
          total += 1 * r_50_59;
        }
        if (r_60_74 !== 0) {
          total += 5 * r_60_74;
        }
        if (r_75_84 !== 0) {
          total += 7 * r_75_84;
        }
        if (r_85_94 !== 0) {
          total += 8 * r_85_94;
        }
        if (r_95_100 !== 0) {
          total += 10 * r_95_100;
        }
      }

      console.log(total);

      return total;
    },
    async getListRangosEvaluacionesPersona() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path:
            "EstadisticasEvaluacionesEmpresaV2/ListRangosEvaluacionesPersona/" +
            this.usuario.id,
        });
        console.log("list rangos evaluaciones persona...", res);
        if (res.success) {
          const cantidadesPorRango = {
            r_50_59: 0,
            r_60_74: 0,
            r_75_84: 0,
            r_85_94: 0,
            r_95_100: 0,
          };

          res.data.forEach((evaluacion) => {
            if (evaluacion.rango) {
              if (cantidadesPorRango[evaluacion.rango]) {
                cantidadesPorRango[evaluacion.rango] += evaluacion.cantidad;
              } else {
                cantidadesPorRango[evaluacion.rango] = evaluacion.cantidad;
              }
            }
          });

          console.log(cantidadesPorRango);

          this.listRangosEvaluaciones = {
            empresaId: res.data[0].empresaId,
            nombre_empresa: res.data[0].nombre_empresa,
            evaluadoId: res.data[0].evaluadoId,
            nombreEvaluado: res.data[0].nombreEvaluado,
            ...cantidadesPorRango,
          };

          console.log(this.listRangosEvaluaciones);
        }
      } catch (error) {
        console.log("err", error);
      }
    },
    async getCanjesLog() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "CanjesMarketLog/ListByPersona/" + this.usuario.id,
        });
        console.log("list canjes persona...", res);
        if (res.success) {
          this.listCanjes = res.data;
        }
      } catch (error) {
        console.log("err", error);
      }
    },
    changeMode() {
      let dark =
        localStorage.getItem("modoseleccionado") == true ||
        localStorage.getItem("modoseleccionado") == "true"
          ? true
          : false;
      const body = document.querySelector("body");
      if (dark) {
        body.classList.add("dark");
        localStorage.setItem("modoseleccionado", true);
      } else {
        body.classList.remove("dark");
        localStorage.setItem("modoseleccionado", false);
      }
    },
    showModal() {
      //this.$store.commit('modalShowRefresh', false)
      // console.log('modalShowRefresh', this.$store.state.modalShow)
      this.$store.commit("modalShowRefresh", true);
      //console.log('modalShowRefresh', this.$store.state.modalShow)
    },
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "PersonaTicket/GetOpenTickets",
        });
        console.log("tickets... ", res);
        if (res.length > 0) {
          if (this.usuario.rol.nivel == 4) {
            this.listaTickets = res.filter(
              (x) =>
                (x.paraId == null || x.paraId == this.usuario.id) &&
                x.estado == 1
            );
          } else {
            this.listaTickets = res.filter(
              (x) => x.paraId == this.usuario.id && x.estado == 1
            );
          }
        } else {
          this.listaTickets = [];
        }
      } catch (error) {
        this.listaTickets = [];
        console.log("err", error);
      }
    },
  },
};
</script>
<style>
.icon-item {
  margin-left: .5rem; 
  cursor: pointer;
  transition: .3s; 
}
.icon-item:hover {
  transform: scale(1.1);
}
</style>
